import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'bg-wrg-blue-100 text-wrg-blue-700',
  success: 'bg-green-100 text-green-700',
  warning: 'bg-amber-100 text-amber-700',
  error: 'bg-red-100 text-red-700',
  neutral: 'bg-slate-100 text-slate-600',
  info: 'bg-blue-100 text-blue-700',
  secondary: 'bg-slate-100 text-slate-600',
};

const dotColors = {
  primary: 'bg-wrg-blue-500',
  success: 'bg-green-500',
  warning: 'bg-amber-500',
  error: 'bg-red-500',
  neutral: 'bg-slate-500',
  info: 'bg-blue-500',
  secondary: 'bg-slate-500',
};

const sizes = {
  sm: 'px-1.5 py-px text-2xs',
  md: 'px-2 py-0.5 text-2xs',
  lg: 'px-2.5 py-0.5 text-xs',
};

export function Badge({
  children,
  variant = 'neutral',
  size = 'md',
  className,
  dot,
  ...props
}) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full font-medium',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {dot && (
        <span
          className={clsx(
            'w-1.5 h-1.5 rounded-full',
            dotColors[variant]
          )}
        />
      )}
      {children}
    </span>
  );
}
